const temaLight = {
  titulo: "light",
  temaDarkAtivo: false,
  cores: {
    //BRAND
    brand10: "rgba(209, 235, 250, 1)",
    brand20: "rgba(163, 215, 245, 1)",
    brand30: "rgba(106, 188, 236, 1)",
    brand40Default: "rgba(35, 160, 232, 1)",
    brand50: "rgba(27, 125, 181, 1)",
    brand60: "rgba(16, 72, 105, 1)",
    brand70: "rgba(47, 83, 105, 1)",
    brand80: "rgba(5, 31, 46, 1)",
    brand85: "rgba(245, 251, 255, 1)",
    brand90: "rgba(1, 7, 10, 1)",
    brand900: "rgba(215, 81, 0, 1)",
    brand1000: "rgba(255, 87, 34, 1)",

    //NEUTRAL

    neutral100: "rgba(255, 255, 255, 1)",
    neutralBackground99: "rgba(251, 252, 255, 1)",
    neutral95: "rgba(220, 227, 233, 0.99)",
    neutral90: "rgba(192, 199, 205, 1)",
    neutral80: "rgba(194, 199, 207, 1)",
    neutral70: "rgba(165, 172, 178, 1)",
    neutral60: "rgba(138, 146, 151, 1)",
    neutral50: "rgba(113, 120, 125, 1)",
    neutral40: "rgba(88, 95, 100, 1)",
    neutral30: "rgba(54, 68, 77, 1)",
    neutral20: "rgba(64, 72, 76, 1)",
    neutral10: "rgba(33, 36, 38, 1)",
    neutralVariant10: "rgba(23, 28, 34, 1)",
    neutral0: "rgba(0, 0, 0, 1)",
    neutral99: "rgba(251, 252, 255, 1)",

    //SURFACE
    surfaceBackground1: "rgba(243, 243, 243, 1)",
    surfaceBackground2: "rgba(224, 222, 222, 1)",
    surface2: "rgba(255, 255, 255, 1)",
    surface3: "rgba(245, 251, 255, 1)",
    surface4: "rgba(232, 247, 255, 1)",
    surface5: "rgba(255, 255, 255, 1)",
    surfaceTableCell: "rgba(245, 251, 255, 1)",
    surface6: "rgba(51, 51, 51, 1)",

    surface7: "rgba(232, 247, 255, 1)",

    //Primary
    textActionPrimary: "rgba(255, 255, 255, 1)",
    textActionPrimaryAlernative: "rgba(5, 31, 46, 1)",
    surfaceActionActivePrimary: "rgba(0, 100, 149, 1)",
    surfaceActionHoverPrimary: "rgba(35, 160, 232, 1)",
    surfaceActionPressedPrimary: "rgba(0, 51, 80, 1)",

    //Success
    textActionSuccess: "rgba(255, 255, 255, 1)",
    textActionSuccessAlternative: "rgba(255, 255, 255, 1)",
    surfaceActionActiveSuccess: "rgba(0, 109, 68, 1)",
    surfaceActionHoverSuccess: "rgba(0, 82, 50, 1)",
    surfaceActionPressedSuccess: "rgba(0, 33, 17, 1)",

    //Disabled
    textActionDisabled: "rgba(33, 36, 38)",
    surfaceActionDisabled: "rgba(220, 227, 233)",

    //OVERLAY
    overlay: "rgba(1,7,10,0.8)",

    //ACTION
    actionActive: "rgba(0, 100, 149, 1)",
    actionHover: "rgba(0, 100, 149, 1)",
    actionHover2: "rgba(35, 160, 232, 1)",
    actionPressed: "rgba(0, 51, 80, 1)",
    actionDisable: "rgba(220, 227, 233, 1)",
    InverseActionDisable: "rgba(88, 95, 100, 1)",

    textAction: "rgba(255, 255, 255, 1)",
    textActionDisable: "rgba(33, 36, 38, 1)",

    //SEMANTIC - ERRO
    semanticDanger1: "rgba(65, 0, 2, 1)",
    semanticDanger2: "rgba(186, 26, 26, 1)",
    semanticDanger3: "rgba(255, 218, 214, 1)",
    semanticDanger4: "rgba(255, 218, 214, 1)",

    //SEMANTIC - SUCESSO
    semanticSuccess3: "rgba(0, 109, 68, 1)",
    semanticSuccess2: "rgba(209, 255, 238, 1)",
    semanticSuccess1: "rgba(0, 33, 17, 1)",
    semanticSuccess4: "rgba(22, 156, 52, 1)",
    semanticSuccess1Antiga: "rgba(22, 156, 52, 1)",
    semanticSuccessBtn: "rgba(0, 109, 68, 1)",

    //SEMANTIC - INFO
    semanticInfo3: "rgba(0, 97, 164, 1)",
    semanticInfo2: "rgba(209, 228, 255, 1)",
    semanticInfo1: "rgba(0, 29, 54, 1)",

    //SEMANTIC - ALERT
    semanticAlert3: "rgba(113, 92, 0, 1)",
    semanticAlert2: "rgba(255, 225, 123, 1)",
    semanticAlert1: "rgba(35, 27, 0, 1)",

    //toastify
    toastifySucessoFundo: "rgba(210, 255, 239, 1)",
    toastifySucessoTexto: "rgba(6, 109, 70, 1)",
    toastifyInfoFundo: "rgba(209, 228, 253, 1)",
    toastifyInfoTexto: "rgba(0, 29, 53, 1)",
    toastifyErrorFundo: "rgba(255, 215, 215, 1)",
    toastifyErrorTexto: "rgba(185, 29, 32, 1)",
    toastifyWarningFundo: "rgba(255, 225, 123, 1)",
    toastifyWarningTexto: "rgba(113, 92, 0, 1)",
    toastifyAlternativeWarningFundo: "rgba(242, 194, 159, 1)",
    toastifyAlternativeWarningTexto: "rgba(57, 27, 0, 1)",

    //Legenda mapa de mesas
    mesaLivre: "rgba(209, 228, 253, 1)",
    mesaOcupada: "rgba(171, 235, 212, 1)",
    mesaSolicitouConta: "rgba(242, 194, 159, 1)",
    mesaReservada: "rgba(237, 240, 191, 1)",
    mesaAgrupada: "rgba(202, 191, 240, 1)",

    //Extras

    textoSimples: "rgba(33, 36, 38, 1)",
    textoSimples2: "rgba(14, 32, 49, 1)",
    textoInverso: "rgba(255, 255, 255, 1)",
    brand40neutral100: "rgba(35, 160, 232, 1)",
    neutral40neutral100: "rgba(88, 95, 100, 1)",
    brand10brand80: "rgba(209, 235, 250, 1)",
    semanticSuccess3SemanticSuccess2: "rgba(0, 109, 68, 1)",
    brand10neutral20: "rgba(209, 235, 250, 1)",
    neutral100brand70: "rgba(255, 255, 255, 1)",
    neutral100brand80: "rgba(255, 255, 255, 1)",
    brand70neutral100: "rgba(47, 83, 105, 1)",
    neutral105: "rgba(88, 95, 100, 1)",
    neutral110: "rgba(192, 199, 205, 1)",
    neutral40ActionDisable: "rgba(138, 146, 151, 1)",
    sufacedark3Neutral90: " rgba(192, 199, 205, 1)",
    textoSimples3: "rgba(255, 255, 255, 1)",
    corCardLoja: "rgba(245, 251, 255, 1)",
    numeroDaLoja: "rgba(113, 120, 125, 1)",
    tipoDaLoja: "rgba(138, 146, 151, 1)adicionar",
    textoModal: "rgba(44, 49, 55, 1)",
    botaoModal: "rgba(50, 50, 50, 1)",
    backgroundInput: "rgba(255, 255, 255, 0.4)",
    corInput: "rgba(64, 72, 76, 1)",
    corBoxPagina: "rgba(113, 120, 125, 1)",
    backgroundBoxPagina: "rgba(255, 255, 255, 0.8)",
    corHr: "rgba(0, 0, 0, 0.2)",
    corCardRelatorioClientes: "rgba(232, 245, 253, 1)",
    textoContrato: "rgba(13, 13, 13, 1)",
    corCheckbox: "rgba(31, 31, 31, 1)",
    accordionEdicao: "rgba(233, 241, 255, 1)",
    accordionIcon: "rgba(19, 124, 185, 1)",
    corTituloAccordion: "rgba(19, 124, 185, 1)",
    corBGAccordion: "rgba(233, 241, 255, 1)",
    grayScale600: "rgba(94, 94, 94, 1)",
    transparent: "rgba(0, 0, 0, 0.0)",
    bordaCheckbox: "rgba(90, 95, 102, 1)",
    semanticSuccess5: "rgba(0, 109, 68, 1)",
    semanticAlert1Antiga: "rgba(255, 248, 214, 1)",
    borderAccordion: " rgba(0, 0, 0, 0.12)",
    linhaBorda: "rgba(0, 0, 0, 0.25)",
    textoCard: "rgba(33, 36, 38, 1)",
    bordaCard: "rgba(0, 0, 0, 0.20)",
    textoCaminho: "rgba(0, 29, 52, 1)",
    textoPopup: "rgba(113, 120, 125, 1)",
    backgroundTituloModal: "rgba(255, 255, 255, 1)",
    bordaCardMeioPublicidade: "rgba(0,0,0,0.1)",
    iconeEditar: "rgba(255, 255, 255, 1)",
    iconeExcluir: "rgba(255, 255, 255, 1)",
    fundoEditar: "rgba(0, 100, 149, 1)",
    fundoExcluir: "rgba(186, 26, 26, 1)",
    visualizarEmpresa: "rgba(35, 161, 232, 1)",
    textSelecionarEmpresa: "rgba(33, 36, 38, 1)",
    imagemPlaceholder: "rgba(217, 217, 217, 1)",
    stroke: "rgba(10, 45, 85, 0.2)",
    bgCheckBoxContainer: "rgba(191, 222, 240, 1)",
    clientSecretBg: "rgba(209, 228, 255, 1)",
    cancelIcon: "rgba(147, 0, 10, 1)",
    hoverTabela: "rgba(0, 100, 149, 0.2)",
    chipRoxo: "rgba(235, 214, 255, 1)",
    textoChipRoxo: "rgba(87, 26, 186, 1)",
    linhaAzulTabela: "rgba(204, 230, 255, 1)",
    menuCardapioFundo: "rgba(209, 235, 250, 1)",
    menuCardapioFundoTexto: "rgba(0, 100, 149, 1)",
    menuCardapioFundoItemSelecionado: "rgba(25, 118, 210, 1)",
    corStatusCinza: "rgba(113, 120, 125, 0.7)",
    corFonteTextoModalPedidoCompra: "rgba(44, 49, 55, 1)",
    corFonteTextoModalPedidoCompraHover: "rgba(255, 255, 255, 1)",
    corTextoCard: "rgba(33, 36, 38, 1)",
    corFundoCardTotalProdutos: "rgb(209, 235, 250)",
    warning: "rgba(236, 195, 0, 1)",
    corInputDisabled: "rgba(0, 0, 0, 0.7)",
    chipRecomendado: "rgba(191, 222, 240, 1)",
    bgCard: "rgba(209, 235, 250, 1)",
    bgLinhaCombo: "rgba(244, 244, 244, 1)",
    corSubTabela: "rgba(163, 215, 245, 1)",
    surfacebg5Dashboard: "rgba(191, 222, 240, 1)",
    backgroundCardDashboard: "rgba(251, 252, 255, 1)",
    statusSucessoCrmConsumidor: "rgba(0, 109, 68, 1)",
    backgroundMensagemSugerida: "#D1EBFA",
    textoMensagemSugerida: "#006495",
    backgroundInputTooltip: "rgba(109, 109, 109, .9)",
    backgroundReactTooltip: "rgba(94, 94, 94, .5)",
    backgroundMaterialTooltip: "rgba(97, 97, 97, 0.92)",
    chipRoxoClaro: "rgba(237, 214, 255, 1)",
    chipRoxoClaroTexto: "rgba(146, 26, 186, 1)",
    painelPedidosBackgroundDetalhes: "rgba(236, 247, 253, 1)",
    headerTabelaAlternativo: "rgba(163, 215, 245, 1)",
    bordaTabela: "rgba(191, 222, 240, 1)",
  },
  adaptativo: function (cor1, cor2) {
    return this.cores[cor1];
  },
  getCorTema: function (light, dark) {
    return light;
  },
};

export default temaLight;
